module.exports = __webpack_public_path__ + "/fonts/BisnodeSans-Bold.woff";